import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            isLoggedIn: false,
            token: null,
            inPage: false,
            user: {
                fullname: null,
                balance: 0,
            },
            startDate: '',
            isFetchedStartDate: false,
            history: null,
        };
    },
    mutations,
    actions,
    getters,
};
